import { useSyncExternalStore } from 'react';

import { getDevicePixelRatio, subscribeToDevicePixelRatio } from './utils';

const useDevicePixelRatio = () =>
  useSyncExternalStore(subscribeToDevicePixelRatio, getDevicePixelRatio);

export default useDevicePixelRatio;
